import { SquareArrowOutUpRight } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";

import { FastAverageColor } from "fast-average-color";

export default function SponsorAppCard({
  cardKey,
  imgPath,
  name,
  des,
  status,
  link,
  onUpdate,
}) {
  const [isEnable, setIsEnable] = useState(status);
  const [imageColor, setImageColor] = useState("#000");
  const imgRef = useRef();

  useEffect(() => {
    const fac = new FastAverageColor();
    const img = imgRef.current;

    if (!img) return;

    fac
      .getColorAsync(img)
      .then((color) => {
        const opacity = 0.3; // 👈 your custom opacity
        const rgba = color.rgba.replace(/[\d.]+\)$/g, `${opacity})`);
        setImageColor(rgba); // ✅ auto color from image
      })
      .catch(() => {
        setImageColor("#000"); // fallback
      });

    return () => fac.destroy();
  }, [imgPath]);

  return (
    <div
      key={cardKey}
      style={{ backgroundColor: imageColor }}
      className="flex bg-slate-200 dark:bg-slate-500/30 border border-slate-600 rounded-lg p-2 space-x-2"
    >
      <img
        ref={imgRef}
        crossOrigin="anonymous"
        className="w-10 h-10 rounded-lg"
        src={imgPath}
        alt=""
      />
      <div className="flex flex-col">
        <span className="text-sm  flex items-center justify-start dark:text-slate-200 text-slate-700">
          {name}
          <SquareArrowOutUpRight
            onClick={() => {
              window.open(link, "_blank");
            }}
            className="ml-2 cursor-pointer text-blue-500"
            size={14}
          />
        </span>
        <span className="text-[12px] dark:text-slate-400 text-slate-700">
          {des}
        </span>
      </div>
      <div className="flex items-center justify-center ml-auto">
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={isEnable}
            onChange={(e) => {
              const value = e.target.checked;
              setIsEnable(value);
              onUpdate(value);
            }}
          />
          <div className="w-10 h-5 bg-gray-300 dark:bg-gray-700 rounded-full peer peer-checked:bg-blue-600 transition-all after:content-[''] after:absolute after:w-4 after:h-4 after:bg-white after:rounded-full after:top-[2px] after:left-[2px] peer-checked:after:translate-x-5 after:transition-all border border-slate-400"></div>
        </label>
      </div>
    </div>
  );
}
